import Vue from 'vue';
import VueInternationalization from 'vue-i18n';
import translation from "@/plugins/translation";

Vue.use(VueInternationalization);

export default new VueInternationalization({
    locale: navigator.language,
    messages: translation,
});